import {BehaviorSubject} from "rxjs";

export class CroppieOptionsService {

    public static instance = [CroppieOptionsService];

    private croppieOptionsSubject: BehaviorSubject<any> = new BehaviorSubject({
        viewport: {
            width: 400,
            height: 400
        },
        boundary: {
            width: 410,
            height: 410
        }
    });

    public submitNewOptions = (options: any) => {
        this.croppieOptionsSubject.next(options);
    };

    public subscribeForOptions = (observer: (options: any) => void) => {
        this.croppieOptionsSubject.subscribe(observer)
    }

}